import { render, staticRenderFns } from "./NewPlayerMessage.vue?vue&type=template&id=e04b52e6&scoped=true&"
import script from "./NewPlayerMessage.vue?vue&type=script&lang=js&"
export * from "./NewPlayerMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04b52e6",
  null
  
)

export default component.exports